export default __webpack_public_path__ + "static/media/1908.65979828.png";